<div id="root-container" [@visibilityChanged]="isInitializedBrand" [class]="'container-fluid ' + brand">
    <app-loading-screen></app-loading-screen>
    <app-nav id="appNav"></app-nav>
    <div>
        <router-outlet></router-outlet>
    </div>
    <div class="clearfix"></div>
</div>